var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPattern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7083 23.9583H7.29163C6.46282 23.9583 5.66797 23.6291 5.08192 23.043C4.49587 22.457 4.16663 21.6621 4.16663 20.8333V4.16663C4.16663 3.33782 4.49587 2.54297 5.08192 1.95692C5.66797 1.37087 6.46282 1.04163 7.29163 1.04163H17.7083C18.5371 1.04163 19.332 1.37087 19.918 1.95692C20.5041 2.54297 20.8333 3.33782 20.8333 4.16663V20.8333C20.8333 21.6621 20.5041 22.457 19.918 23.043C19.332 23.6291 18.5371 23.9583 17.7083 23.9583ZM7.29163 3.12496C7.01536 3.12496 6.75041 3.23471 6.55506 3.43006C6.35971 3.62541 6.24996 3.89036 6.24996 4.16663V20.8333C6.24996 21.1096 6.35971 21.3745 6.55506 21.5699C6.75041 21.7652 7.01536 21.875 7.29163 21.875H17.7083C17.9846 21.875 18.2495 21.7652 18.4449 21.5699C18.6402 21.3745 18.75 21.1096 18.75 20.8333V4.16663C18.75 3.89036 18.6402 3.62541 18.4449 3.43006C18.2495 3.23471 17.9846 3.12496 17.7083 3.12496H7.29163ZM14.5833 17.7083H10.4166V19.7916H14.5833V17.7083Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern);
export default __webpack_public_path__ + "static/media/pattern.50c8fa714555643a0e9079ce38b1193c.svg";
export { ForwardRef as ReactComponent };